import {Product, Variant} from "../../../../models/product";
import {Component, h} from "preact";
import styles from './style.module.scss';
import {productService} from "../../../../services/product-service";
import ProductBrand from "../../../product-brand";
import ProductTag from "../../../product-tag";
import {i18nService} from "../../../../services/i18n-service";
import App from "../../../app";
import {ProductPrice} from "../../../product-price";
import {NY_CountryService} from "../../../../services/country-service";

interface Props {
  product: Product;
  variant: Variant;
}

export default class ProductInfoDesktop extends Component<Props> {

  render() {
    const variant = this.props.variant;

    return (
        <div class={styles['product-info']}>

            <div class={styles['product-tag']}>
                <ProductTag variant={variant}/>
            </div>

            <div class={styles.description}>
                {i18nService.translate(productService.getTranslationKey(this.props.product))}
            </div>

            <ProductPrice variant={variant} styles={styles}/>

            {NY_CountryService.showVariablePriceCaption(App.countryCode) && (
                <p className={styles['price-caption']}>
                   {i18nService.translate("variable_price_caption")}
                </p>
            )}

            <div class={styles['brand-product-number']}>
                <div class={styles.brand}>
                    <ProductBrand product={this.props.product}/>
                </div>
                <div class={styles['product-number']}>
                    {variant.productId}
                </div>
            </div>
        </div>
    )
  }
}